import { Model } from './model';

export class CreditAlert extends Model {
  enabled: boolean;
  notifyByEmail: boolean;
  notificationEmail: string;
  notifyBySms: boolean;
  notificationMobileNumber: string;
  creditType: string;
  alertLimit: number;
  smsType: string;
}

export class CreditAlerts extends Model {
  creditAlert1: CreditAlert;
  creditAlert2: CreditAlert;
  creditAlert3: CreditAlert;
}
